import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table } from 'antd';

class CamdetectErrorsTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    render() {
        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Název kamery',
            dataIndex: 'camera.cameraName',
            key: 'camera.cameraName',
            width: 30,
        }, {
            title: 'Typ',
            dataIndex: 'type',
            key: 'type',
            width: 30,
        }, {
            title: 'Typ chyby',
            dataIndex: 'mmsgtype',
            key: 'mmsgtype',
            width: 30,
        }, {
            title: 'Zpráva',
            dataIndex: 'message',
            key: 'message',
            width: 150,
        }, {
            title: 'Časová značka',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
            render: (text, record) => {
                return moment(text).format('L LTS');
            }
        }]
        return (
            <Table
                size='small'
                rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
                loading={this.props.loading ? this.props.loading : false}
                columns={columns}
                dataSource={this.props.data}
                onChange={this.handleChange}
                pagination={{
                    showSizeChanger: true,
                    defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                        ? parseInt(localStorage.getItem('table_pageSize'))
                        : 10,
                    onShowSizeChange: (current, size) => {
                        localStorage.setItem('table_pageSize', size);
                    }
                }}
                style={{ border: '0px' }} />
        );
    }
}

export default CamdetectErrorsTable;


// WEBPACK FOOTER //
// ./src/components/CamdetectErrorsTable.js